/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { DifformitaStudente } from './difformita-studente';


export interface ServizioMensaDifformitaPastiDTO { 
    totale_studenti?: number;
    studenti_con_difformita?: number;
    studenti_ok?: number;
    difformita?: Array<DifformitaStudente>;
}

